<template>
  <section
    class="case-creation__step case-creation__patient-information"
    v-loading="loading"
  >
    <div>
      <div class="case-creation__step case-creation__test">
        <div class="case-creation__card attachments pb-10">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-test-reports.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Test Performed By</h3>
            </div>
          </div>

          <div class="case-creation__body pb-0" v-if="hasCaseTypes">
            <div class="test-performed-by-block">
              <el-row>
                <el-col :span="24">
                  <div
                    class="input-value view-cases"
                    v-if="
                      getCaseInformation && getCaseInformation.test_performed_by
                    "
                  >
                    <div class="value">
                      <ul>
                        <li class="value-header">
                          <span> Case Type </span>
                        </li>
                        <li class="value-header">
                          <span> User Name </span>
                        </li>
                        <li class="value-header" v-if="!isCaseCompleted">
                          <span> Actions </span>
                        </li>
                      </ul>
                      <ul
                        v-for="(
                          item, index
                        ) in getCaseInformation.test_performed_by"
                        :key="index"
                      >
                        <li>
                          <span class="case-type">
                            {{ caseTypeMap[item.case_type] }}
                          </span>
                        </li>
                        <li>
                          <span class="username-type" v-if="item.user">
                            {{ item.user.first_name }} {{ item.user.last_name }}
                          </span>
                          <span class="username-type" v-else> -- </span>
                        </li>
                        <li v-if="!isCaseCompleted">
                          <span
                            class="username-type cursor"
                            @click="onEdit(item)"
                          >
                            Edit
                          </span>
                          <span
                            class="username-type cursor"
                            @click="onDeleteTestPerformed(item)"
                          >
                            <img
                              style="position: relative; top: 1px"
                              class="action-inactive"
                              src="@/assets/images/icons/actions/delete-active.svg"
                              alt="icon"
                              width="10"
                            />
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            class="case-creation__body"
            v-if="hasTestPerformed || testPerformedBy"
          >
            <div class="vue-form" v-if="!isCaseCompleted">
              <el-form>
                <el-row :gutter="15">
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                    <div
                      class="case-creation__input"
                      v-if="
                        getCaseInformation &&
                        getCaseInformation.case_types &&
                        getCaseInformation.case_types.length
                      "
                    >
                      <el-form-item class="mb-0">
                        <label for="text"> Case Type </label>
                        <el-select
                          v-model="selectedCaseType"
                          placeholder="Select CaseType"
                          :disabled="testPerformedBy"
                        >
                          <el-option
                            v-for="(
                              caseType, index
                            ) of getCaseInformation.case_types"
                            :label="caseTypeMap[caseType]"
                            :value="caseType"
                            :key="index"
                            :disabled="checkCaseTypeDisable(caseType)"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                    <div
                      class="case-creation__input"
                      v-if="getAllUsers && getAllUsers.data"
                    >
                      <el-form-item>
                        <label for="text"> Test Performed by User </label>
                        <el-select
                          v-model="selectedUser"
                          filterable
                          placeholder="Select User"
                        >
                          <el-option
                            v-for="(user, index) in usersList"
                            :key="index"
                            :label="user.first_name + user.last_name"
                            :value="user._id"
                            :disabled="isInactiveStatus(user)"
                          >
                            <span style="float: left">{{
                              user.first_name + user.last_name
                            }}</span>
                            <span
                              v-if="isInactiveStatus(user)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                            >
                              Inactive
                            </span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="case-creation__input" v-else>
                      <el-form-item>
                        <label for="text"> Test Performed by User </label>
                        <el-select
                          v-model="selectedUser"
                          filterable
                          placeholder="Select User"
                          disabled
                        >
                          <el-option
                            v-for="(user, index) in currentUserData"
                            :key="index"
                            :label="user.first_name + user.last_name"
                            :value="user._id"
                            :disabled="isInactiveStatus(user)"
                          >
                            <span style="float: left">{{
                              user.first_name + user.last_name
                            }}</span>
                            <span
                              v-if="isInactiveStatus(user)"
                              style="
                                float: right;
                                color: #eb5757;
                                font-size: 13px;
                                padding-left: 10px;
                              "
                            >
                              Inactive
                            </span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :xl="8" :lg="8" :md="8" :sm="12" :xs="12">
                    <div class="case-creation__actions">
                      <ul class="list" style="justify-content: flex-start">
                        <li>
                          <el-button
                            class="btn cancel-button"
                            type="button"
                            @click="clearFields"
                          >
                            Cancel
                          </el-button>
                        </li>
                        <li v-if="testPerformedBy">
                          <button
                            type="button"
                            class="btn save-button"
                            @click="updatedTestPerformed"
                            v-loading="updateLoading"
                            :disabled="disableSubmit"
                          >
                            Update
                          </button>
                        </li>
                        <li v-else>
                          <el-button
                            class="btn save-button"
                            type="button"
                            @click="sumbitTestPerformedBy"
                            :loading="loading"
                            :disabled="disableSubmit"
                          >
                            Submit
                          </el-button>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="mini-reason-for-change" v-if="testPerformedBy">
        <ResonForChange
          v-if="testPerformedByDeletePopup"
          v-on:close="testPerformedByDeletePopup = false"
          v-on:reasonSubmit="onTakeAction"
          title="Reason for Update"
        ></ResonForChange>
      </div>
      <div class="mini-reason-for-change" v-else>
        <ResonForChange
          v-if="testPerformedByDeletePopup"
          v-on:close="testPerformedByDeletePopup = false"
          v-on:reasonSubmit="onTakeAction"
          title="Reason for remove"
        ></ResonForChange>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
// import caseDataHelper from "@/mixins/caseDataHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      testPerformedByDeletePopup: false,
      loading: false,
      updateLoading: false,
      testPerformedBy: false,
      performedId: "",
      selectedCaseType: "",
      selectedUser: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypesList: [],
      testPerfomedCaseTypes: [],
      usersList: [],
      currentUserData: [],
    };
  },
  // mixins: [caseDataHelper],
  components: {
    ResonForChange,
  },
  computed: {
    getCaseTypes() {
      return this.caseTypesList;
    },
    checkCaseTypeDisable() {
      let testPerfomedCaseTypes = [];
      if (
        this.getCaseInformation.test_performed_by &&
        this.getCaseInformation.test_performed_by.length
      ) {
        this.getCaseInformation.test_performed_by.forEach(function (arrayItem) {
          testPerfomedCaseTypes.push(arrayItem.case_type);
        });
      }
      return (caseType) => {
        for (let i = 0; i < testPerfomedCaseTypes.length; i++) {
          if (
            testPerfomedCaseTypes &&
            testPerfomedCaseTypes.length &&
            testPerfomedCaseTypes[i].indexOf(caseType) == 0
          ) {
            return true;
          }
        }
        return false;
      };
    },
    hasTestPerformed() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.test_performed_by &&
        this.getCaseInformation.test_performed_by.length == 1 &&
        this.getCaseInformation.case_types.length == 1
      ) {
        return false;
      } else if (
        this.getCaseInformation &&
        this.getCaseInformation.test_performed_by &&
        this.getCaseInformation.test_performed_by.length == 2 &&
        this.getCaseInformation.case_types.length == 2
      ) {
        return false;
      } else if (
        this.getCaseInformation &&
        this.getCaseInformation.test_performed_by &&
        this.getCaseInformation.test_performed_by.length == 3 &&
        this.getCaseInformation.case_types.length == 3
      ) {
        return false;
      }
      return true;
    },

    hasCaseTypes() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.test_performed_by &&
        this.getCaseInformation.test_performed_by.length
      ) {
        return true;
      }
      return false;
    },
    isCaseCompleted() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.status &&
        this.getCaseInformation.status == "COMPLETE"
      ) {
        return true;
      }
      return false;
    },

    disableSubmit() {
      if (this.selectedCaseType && this.selectedUser) {
        return false;
      }
      return true;
    },
    ...mapGetters("cases", [
      "getCaseInformation",
      "getTestPerformedByStatus",
      "getTestPerformedUpdateStatus",
      "getTestPerformedByDeleteStatus",
    ]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
  },
  async mounted() {
    this.setUserData();
    await this.fetchAllUserAccounts();
    this.getCaseTypesFromCase();
  },
  watch: {
    getCaseInformation: {
      immediate: true,
      handler: function () {
        this.defaultCaseType();
      },
    },
  },
  methods: {
    defaultCaseType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.length
      ) {
        this.selectedCaseType = this.getCaseInformation.case_types[0];
      }
    },
    setUserData() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.currentUserData.push(this.getAuthenticatedUser);
        this.selectedUser = this.getAuthenticatedUser._id;
      }
    },
    getCaseTypesFromCase() {
      if (this.getCaseInformation && this.getCaseInformation.case_types) {
        this.caseTypesList = this.getCaseInformation.case_types;
      }
    },

    updatedTestPerformed() {
      this.testPerformedByDeletePopup = true;
    },
    onTakeAction(reason) {
      if (this.testPerformedBy) {
        this.updatedTestPerformedBy(reason);
      } else {
        this.onDelete(reason);
      }
    },
    onDeleteTestPerformed(item) {
      this.testPerformedByDeletePopup = true;
      this.deleteId = item;
    },
    async onDelete(reason) {
      try {
        this.loading = true;
        console.log(reason);
        let params = {
          case_id: this.$route.params.case_id,
          test_performed_id: this.deleteId._id,
        };
        params.reason = reason;
        await this.$store.dispatch("cases/deleteTestPerformedBy", params);
        if (this.getTestPerformedByDeleteStatus) {
          successNotification("Test Performed by User Deleted Successfully");
          window.location.reload();
          this.clearFields();
        } else {
          errorNotification("Error in Delete User");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllUserAccounts() {
      try {
        let params = {
          get_all: true,
          order_by: "first_name",
          order_type: "asc",
          status:"ACTIVE"
        };
        await this.$store.dispatch("userAccounts/fetchAllUserAccounts", params);
        if (this.getAllUsers && this.getAllUsers.data) {
          const usersForTestPerformed = ["LAB_TECHNOLOGIST"];
          const authenticatedUser = this.getAuthenticatedUser;
          const matchedUser = this.getAllUsers.data.find(
            (user) => user._id === authenticatedUser._id
          );

          this.usersList = this.getAllUsers.data.filter((user) =>
            usersForTestPerformed.includes(user.user_type)
          );
          let users = ["LAB_ADMIN", "LAB_MANAGER"];
          if (users.includes(matchedUser.user_type)) {
            this.usersList.push(matchedUser);
            this.selectedUser = matchedUser._id;
          }
        }
      } catch (error) {
        console.error("Error fetching user accounts:", error);
      }
    },
    prepareParams() {
      let params = {
        case_id: this.$route.params.case_id,
        case_type: this.selectedCaseType,
        user: this.selectedUser,
      };
      return params;
    },
    async sumbitTestPerformedBy() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("cases/addTestPerformedBy", params);
        if (this.getTestPerformedByStatus) {
          successNotification("Test Performed by User Added Successfully");
          window.location.reload();
          this.clearFields();
        } else {
          errorNotification("Error in Add User");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async updatedTestPerformedBy(reason) {
      try {
        this.updateLoading = true;
        let params = this.prepareParams();
        params.performed_id = this.performedId;
        params.data_update_reason = reason;
        await this.$store.dispatch("cases/updateTestPerformedBy", params);
        if (this.getTestPerformedUpdateStatus) {
          successNotification("Test Performed Updated Successfully");
          window.location.reload();
          this.clearFields();
        } else {
          errorNotification("Error in Updated Test Performed");
        }
        this.testPerformedByDeletePopup = false;
        this.updateLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    clearFields() {
      this.testPerformedBy = false;
      this.selectedCaseType = "";
      this.selectedUser = "";
    },
    onEdit(item) {
      this.testPerformedBy = true;
      this.performedId = item._id;
      this.selectedCaseType = item.case_type;
      this.selectedUser = item.user._id;
    },
  },
};
</script>
<style lang="scss">
.test-reports-not-available {
  text-align: center;
  padding: 1rem 0;
  color: #f24a65;
  font-weight: 500;
}
.test-performed-by-block {
  .input-value.view-cases .value ul {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 20px;
    li {
      padding: 3px;
      background: none;
      .case-type,
      .username-type {
        font-size: 12px;
        color: #333333;
        font-weight: 500;
        background: #dde7f3;
        border-radius: 30px;
        color: #0a5da6;
        padding: 3px 12px;
        margin: 2px;
        white-space: nowrap;
      }
    }
    .value-header span {
      font-size: 15px;
      color: rgb(148, 126, 126);
      font-weight: 500;
      display: block;
      margin-bottom: 2px;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0 !important;
}
.list {
  padding-bottom: 0 !important;
}
.case-creation__body {
  padding-bottom: 10px;
}
</style>
